import { FetchAPI, FetchOptions, IAuthData, defaultOptionsFetch } from 'ufinet-web-functions'
import { AffectationType } from '../domain/AffectationType'
import { AffectationTypeRepository } from '../domain/repository/AffectationTypeRepository'

export const HttpAffectationTypeRepository: (authData: IAuthData) => AffectationTypeRepository = (authData) => {
	const url = `${process.env.REACT_APP_URL_BACK_GTI}affectationType`

	const fetchOptions: FetchOptions = {
		...defaultOptionsFetch,
		authenticationData: authData,
		sendApiKey: true,
		apiKey: process.env.VITE_API_KEY,
	}

	return {
		findAll: async (options?: FetchOptions): Promise<AffectationType[]> =>
			await FetchAPI.get(`${url}/GetAffectationTypes`, {
				...fetchOptions,
				...options,
			}),
	}
}
